import { useCallback, useState } from "react";

export function useSlice<T>(array: Array<T>, size: number) {
  const [slice, setSlice] = useState(array.slice(0, size));

  const shouldHaveLoadMoreButton = array.length > slice.length;

  const unslice = useCallback(() => {
    return setSlice(array);
  }, [array]);

  return { slice, shouldHaveLoadMoreButton, unslice };
}
